/**
 * @ngdoc service
 * @name BBAdminDashboard.bbTimeZone
 * @description
 * TimeZone service stores information about current display mode and is indispensable when it comes to perform
 * timezone operations on moment objects.
 */
function TimeZoneService($sessionStorage, $log, bbi18nOptions, CompanyStoreService, bbTimeZoneUtils) {
    'ngInject';

    let displayTimeZone =
        bbTimeZoneUtils.getKeyInCustomList(bbi18nOptions.timeZone.default, bbi18nOptions.timeZone.useCustomList);

    return {
        getDisplay,
        getDisplayUTCOffset,
        getCompany,
        getCompanyUTCOffset,

        convertToCompany,
        convertToDisplay,

        determine,
        setDisplay,
        setSessionStorage,

        forceTimeZoneToDisplay
    };

    /**
     * @description Changes
     * @param {moment|String} dateTime If string must be valid ISO string
     * @returns {moment}
     */
    function convertToCompany(dateTime) {
        return convertDateTime(dateTime, CompanyStoreService.time_zone);
    }

    /**
     * @param {moment|String} dateTime If string must be valid ISO string
     * @returns {moment}
     */
    function convertToDisplay(dateTime) {
        return convertDateTime(dateTime, displayTimeZone);
    }

    function convertDateTime(dateTime, timeZone) {
        if (!moment(dateTime).isValid()) $log.error('not valid dateTime', dateTime);
        const converted = moment.tz(dateTime, timeZone);
        return converted;
    }

    function getDisplay() {
        return displayTimeZone;
    }

    function getDisplayUTCOffset() {
        return moment().tz(displayTimeZone).utcOffset();
    }

    function getCompany() {
        return CompanyStoreService.time_zone;
    }

    function getCompanyUTCOffset() {
        return moment().tz(CompanyStoreService.time_zone).utcOffset();
    }

    function determine() {
        const {useBrowser, useCustomList, useCompany} = bbi18nOptions.timeZone;
        const sessionStorage = $sessionStorage.getObject('bbTimeZone');

        if (sessionStorage.displayTimeZone) {
            setDisplay(sessionStorage.displayTimeZone);
            return;
        }

        if (useBrowser || sessionStorage.useBrowserTimeZone) {
            const timeZone = bbTimeZoneUtils.getKeyInCustomList(moment.tz.guess(), useCustomList);
            setDisplay(timeZone);
            return;
        }

        if (useCompany && CompanyStoreService.time_zone) {
            const timeZone = bbTimeZoneUtils.getKeyInCustomList(CompanyStoreService.time_zone, useCustomList);
            setDisplay(timeZone);
        }
    }

    function setDisplay(timeZone) {
        moment.tz.setDefault(timeZone);
        displayTimeZone = timeZone;
    }

    function setSessionStorage(localStorageObj) {
        $sessionStorage.setObject('bbTimeZone', localStorageObj);
    }

    /**
     * @description
     * Transforms moment object in such a way that its date and time remains the same but timezone is set to display.
     */
    function forceTimeZoneToDisplay(datetime) {
        return moment.tz(datetime.clone().subtract(getDisplayUTCOffset(), 'minutes'), displayTimeZone);
    }

}

angular
    .module('BB.i18n')
    .service('bbTimeZone', TimeZoneService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/-i18n/time-zone/time_zone.service.js